import { render, staticRenderFns } from "./set-hold.vue?vue&type=template&id=293c5e81&scoped=true"
import script from "./set-hold.vue?vue&type=script&lang=js"
export * from "./set-hold.vue?vue&type=script&lang=js"
import style0 from "./set-hold.vue?vue&type=style&index=0&id=293c5e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c5e81",
  null
  
)

export default component.exports